import { createContext, useContext, type ReactNode } from 'react'
import type { SedeConfig } from '../../sedi/types'
import { verdeValsesia2 } from '../../sedi/verde-valsesia-2'

/**
 * The sede config for the component tree. `SiteRoutes` provides the config
 * it was mounted with (the browser passes the runtime-resolved sede, the
 * prerender passes `verdeValsesia2`); the default only covers a component
 * rendered outside the site tree, e.g. in isolation.
 *
 * Company data (address, phone, P.IVA, hours, socials) is read from here and
 * is placeholder-gated at every render site — see src/sedi/placeholders.ts.
 */
const SedeContext = createContext<SedeConfig>(verdeValsesia2)

export function SedeProvider({ sede, children }: { sede: SedeConfig; children: ReactNode }) {
  return <SedeContext.Provider value={sede}>{children}</SedeContext.Provider>
}

export function useSede(): SedeConfig {
  return useContext(SedeContext)
}
